import { INTEGRATION_PARTNER } from '../utils/enum';

// Everywhere a case or its documents can come from: a case management system, or cloud storage.

// Litify has no strategy on the PFQ and no entry in the shared INTEGRATION_PARTNER enum. The mock
// requires the button, so it renders disabled and explained rather than opening a dead modal.
export const EASY_MODE_PARTNER_LITIFY = 'litify';

export const EASY_MODE_PARTNERS = [
  { value: INTEGRATION_PARTNER.CHARTSQUAD, text: 'Chart Squad', isAvailable: true },
  { value: INTEGRATION_PARTNER.CASEPEER, text: 'CASEpeer', isAvailable: true },
  {
    value: EASY_MODE_PARTNER_LITIFY,
    text: 'Litify',
    isAvailable: false,
    unavailableReason: 'Litify integration coming soon'
  },
  { value: INTEGRATION_PARTNER.SMARTADVOCATE, text: 'SmartAdvocate', isAvailable: true }
];

export const EASY_MODE_CLOUD_SOURCE = {
  ONE_DRIVE: 'oneDrive',
  DROPBOX: 'dropbox'
};

// The real implementation hides a provider whose credentials are absent (build spec 6.3). Only
// Dropbox has a picker so far; OneDrive renders disabled and explained.
export const EASY_MODE_CLOUD_SOURCES = [
  { value: EASY_MODE_CLOUD_SOURCE.ONE_DRIVE, text: 'OneDrive', iconClasses: 'fa-brands fa-microsoft' },
  { value: EASY_MODE_CLOUD_SOURCE.DROPBOX, text: 'Dropbox', iconClasses: 'fa-brands fa-dropbox' }
];

export const CLOUD_SOURCE_UNAVAILABLE_REASON = 'Connect this provider in My Profile';

export const DROPBOX_UNCONFIGURED_REASON = 'Dropbox is not configured for this environment';
